import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {columns} from "./Columns";
import {onReloadData, setHeader} from "../../../../../redux/actions/layout/interaction/action";
import {deleteShiftApi, loadShiftsApi} from "../../../../../api/setting/timekeeping/shift";
import DG_Menu_Delete from "../../../../../common/menu/delete/Delete";
import DG_Menu_Update_Link from "../../../../../common/menu/update/link/Link";
import CommonList from "../../../../../common/list";
import TableTitle from "../../../../../common/list/components/TableTitle";
import {useSearchParams} from "react-router-dom";
import TableMenu from "../../../../../common/list/components/TableMenu";
import {useLazyQuery} from "@apollo/client";
import useLazyRefetch from "../../../../../custom/graphql/useLazyRefetch";
import {GET_SHIFT_CONFIGS} from "../../../../../api/setting/timekeeping/shift/indexGql";
import {usedGraphqlLazyQuery} from "../../../../../custom/graphql/graphql-client";
import {formatCurrency} from "../../../../../format/Money";

const ShiftList = (props) => {
    const [dataSource, setDataSource] = useState()
    const [totalCount, setTotalCount] = useState()
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {filter, search, reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [searchParams] = useSearchParams();
    const sort = searchParams.get("sort")
    const page = searchParams.get("page");
    const pageSize = searchParams.get("pageSize");
    const [loading,setLoading] = useState(false)

    // const[shiftConfigPage, {data, loading,called }] = useLazyQuery(GET_SHIFT_CONFIGS)
    const[refresh, setRefresh ] = useState(true)
    const {fetchIfNeeded} = useLazyRefetch(GET_SHIFT_CONFIGS)

    const handleOnDelete = (id) => {
        deleteShiftApi(id).then(response => {
            fetchIfNeeded({filter: filter || "isDeleted eq 'false'", page, pageSize, search, sort})
        })
    }

    useEffect(() => {
        setRefresh(true)
        setLoading(true)
        const timeoutId = setTimeout(() => {

            loadShiftsApi({
                filter: filter || "isDeleted eq 'false'",
                page,
                pageSize,
                search,
                 sort
            }).then(res => {
                setDataSource(mapData(res?.items))
                setTotalCount(res?.totalCount)
                setRefresh(false)
            }).finally(() => setLoading(false))

            // usedGraphqlLazyQuery(shiftConfigPage, {
            //     filter: filter || "isDeleted eq 'false'",
            //     page,
            //     pageSize,
            //     search,
            //     sort
            // }).then(res => {
            //     setDataSource(mapData(res?.data?.shiftConfigs?.items))
            //     setTotalCount(res?.data?.shiftConfigs?.totalCount)
            //     setRefresh(false)
            // })

            if (reloadData) {
                dispatch(onReloadData(false))
            }
        },300)

        return () => {
            clearTimeout(timeoutId)
        }

    }, [filter, search, page, pageSize, sort, reloadData])

    useEffect(() => {
        dispatch(setHeader(t("shiftSider.listShift"), null))
    }, [])


    const mapData = (shifts) => {
        if (!shifts) {
            return [];
        }
        return shifts.map((item, index) => ({
            key: item.shiftConfigId,
            shiftId: item.shiftConfigId,
            code: item.code,
            name: item.name,
            flexibleHours: item.flexibleString ? item.flexibleString : t("shiftTitle.no"),
            timeIn: item.timeStartString,
            timeOut: item.timeEndString,
            timeBreak: item.breakTimeStartString,
            endBreak: item.breakTimeEndString,
            checkInFirst: item.checkInBeforeString,
            checkInLater: item.checkOutBeforeString,
            totalHours: formatCurrency(item.flexibleTotalHour),
            totalWork: formatCurrency(item.totalWork),
            menu: <TableMenu restRowClassName={"gap-4 !mr-6"} mode={"setting"}>
                <DG_Menu_Update_Link link={{to: `update/${item.shiftConfigId}`}}/>
                <DG_Menu_Delete id={item.shiftConfigId}
                                content={
                                    <span dangerouslySetInnerHTML={{
                                        __html:  t("tnp.components.timekeeping.text65",{name : `<span class="font-bold">${item.name}</span>` })
                                    }} />
                }
                                onOk={handleOnDelete}/>
            </TableMenu>
        }));
    };

    return (
        <div className={'h-full overflow-hidden'}>
            {
                <>
                    <TableTitle
                        title={t("shiftSider.listShift")}

                    />
                    <CommonList
                        columns={columns}
                        dataSource={dataSource}
                        totalCount={totalCount}
                        // loading={!called || called && loading || refresh}
                        loading={ loading || refresh}
                    />
                </>
            }
        </div>
    );
};

export default ShiftList;
